import React from 'react';
import { Hero } from '../components/Hero';
import { ProductsSection } from '../components/ProductsSection';
import { ValuesSection } from '../components/ValuesSection';
import { TechStackSection } from '../components/TechStackSection';
import { TeamSection } from '../components/TeamSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-cyan-100 selection:text-cyan-900" data-id="element-139">
      <nav className="fixed top-0 left-0 right-0 z-50 bg-slate-950/80 backdrop-blur-md border-b border-slate-800" data-id="element-140">
        <div className="container mx-auto px-4 md:px-6 h-16 flex items-center justify-between" data-id="element-141">
          <div className="flex items-center space-x-2" data-id="element-142">
            <div className="w-8 h-8 bg-cyan-500 rounded-lg flex items-center justify-center" data-id="element-143">
              <span className="text-slate-950 font-bold text-xl" data-id="element-144">R</span>
            </div>
            <span className="font-bold text-xl text-white tracking-tight" data-id="element-145">
              Remote Systems
            </span>
          </div>
          <div className="hidden md:flex items-center space-x-8" data-id="element-146">
            <a href="#products" className="text-sm font-medium text-slate-300 hover:text-white transition-colors" data-id="element-147">
              Products
            </a>
            <a href="#" className="text-sm font-medium text-slate-300 hover:text-white transition-colors" data-id="element-148">
              Company
            </a>
            <a href="#contact" className="text-sm font-medium bg-white text-slate-900 px-4 py-2 rounded-md hover:bg-slate-100 transition-colors" data-id="element-149">
              Contact Us
            </a>
          </div>
        </div>
      </nav>

      <main data-id="element-150">
        <Hero data-id="element-151" />
        <ProductsSection data-id="element-152" />
        <ValuesSection data-id="element-153" />
        <TechStackSection data-id="element-154" />
        <TeamSection data-id="element-155" />
      </main>

      <Footer data-id="element-156" />
    </div>;
}